<mat-menu #menu xPosition="before">
  @if (user$ | async; as user) {
    <div class="menu-title">{{ user.firstName }} {{ user.lastName }}</div>
  }
  <button mat-menu-item (click)="goToProfile()">
    <mat-icon fontSet="material-icons-outlined">person</mat-icon>
    <span>{{ 'Profile' | translate }}</span>
  </button>
  <button mat-menu-item (click)="goToNotifications()">
    <mat-icon fontSet="material-icons-outlined">notifications</mat-icon>
    <span>{{ 'Notifications' | translate }}</span>
  </button>
  <button mat-menu-item [matMenuTriggerFor]="languageMenu">
    <mat-icon>language</mat-icon>
    <span>{{ 'Language' | translate }}</span>
    <span class="current-value">{{ currentLanguage.label }}</span>
  </button>
  @if (isAdmin$ | async) {
    <button mat-menu-item routerLink="/admin/publish/daily-reports">
      <mat-icon fontSet="material-icons-outlined">admin_panel_settings</mat-icon>
      <span>To Admin</span>
    </button>
  }
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="logout()">
    <mat-icon>logout</mat-icon>
    <span>{{ 'Log out' | translate }}</span>
  </button>
</mat-menu>

<mat-menu #languageMenu>
  @for (language of languages; track language.code) {
    <button mat-menu-item (click)="setLanguage(language.code)">
      <mat-icon>{{ language.code === currentLanguage.code ? 'check' : '' }}</mat-icon>
      <span>{{ language.label }}</span>
    </button>
  }
</mat-menu>
